export default "__VITE_ASSET___145$1Ia__"